export const SUPPORTED_LANGUAGE = ['en', 'de', 'es'];

export function isLanguageSupported(value) {
	return SUPPORTED_LANGUAGE.includes(value);
}
